export function getOffset(event) {
    if (event.touches) {
        const touch = event.touches[0];
        const rect = event.target.getBoundingClientRect();

        return {
            x: touch.pageX - rect.left,
            y: touch.pageY - rect.top
        };
    }

    return {
        x: event.offsetX,
        y: event.offsetY
    };
}
